import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { formatRangeFacetValue } from "../helpers";

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-0 ${className}`}
            onClick={() => filter.remove()}
        >
            <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </button>
    )
}

export default function SelectedFilters({isSearch, isSidebar}) {
    const { filters, removeAll } = useProductFilters();
    console.log(filters);
    return (
        filters.length > 0 && (
            <div class={`ns-flex-wrap ns-align-items-center ns-selected-filters-wrapper ${isSidebar ? 'ns-in-sidebar' : ''}`}>
                {isSearch && (
                    <div class="ns-d-flex ns-justify-content-between ns-align-items-center ns-w-100 ns-selected-filters-heading">
                        <div class="ns-font-1">Refine by</div>
                        <span
                            class="ns-anchor ns-text-align-right ns-font-1  ns-clear-all-filters"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear All
                        </span>
                    </div>
                )}
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-container">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter ns-d-flex ns-align-items-center ns-font-1"
                        >
                            <span class="ns-color-black">
                                {filter?.field !== 'price' ? `${filter?.name}: ${filter?.value}` : formatRangeFacetValue(filter?.value)} 
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="ns-anchor ns-text-align-right ns-font-1  ns-clear-all-filters"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Remove all
                </span>
            </div>
        )
    )
}
